import Router, { Route } from 'vue-router';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import {
  PermissionModule,
  UserTokenPermission,
} from '@/store/modules/permission';
import i18n from '@/plugins/i18n';
import { isExpiredNow, configureRoutesAfterLoggedIn } from '@/utils/permission';

const whiteList = ['/login'];
const pathInWhiteList = (path: string) =>
  whiteList.some(p => path.indexOf(p) >= 0);

export const validateUserTokenExisted = (sendNotification: boolean = false) => {
  const valid = !!UserModule.token;
  if (!valid && sendNotification) {
    PermissionModule.SetUserTokenPermission(
      new UserTokenPermission(true, false)
    );
  }
  return valid;
};
export const validateUserTokenNotExpired = (
  sendNotification: boolean = false
) => {
  const valid = !isExpiredNow(UserModule.tokenExpiredTime);
  if (!valid && sendNotification) {
    PermissionModule.SetUserTokenPermission(
      new UserTokenPermission(false, true)
    );
  }
  return valid;
};

export const getPageTitle = (key: string) => {
  const hasKey = i18n.te(`route.${key}`);
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`);
    return `${pageName} - ${process.env.VUE_APP_NAME || ''}`;
  }
  return `${process.env.VUE_APP_NAME || ''}`;
};

export const configRouterPermission = (router: Router) => {
  router.beforeEach(async (to: Route, _: Route, next: any) => {
    // Start progress bar if not active
    AppModule.StartProgress();

    // Determine whether the user has logged in
    if (validateUserTokenExisted() && validateUserTokenNotExpired()) {
      if (UserModule.roles.length === 0) {
        try {
          configureRoutesAfterLoggedIn(router);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(JSON.stringify(err));
          // Remove token and redirect to login page
          UserModule.ResetToken();
          next(`/login?redirect=${to.path}`);
          AppModule.StopProgress();
        }
      }

      if (to.path === '/login') {
        // If is logged in, redirect to the home page
        next({ path: to.redirectedFrom ? to.redirectedFrom : '/' });
        AppModule.StopProgress();
      } else {
        next();
      }
    } else {
      // Token not valid
      if (pathInWhiteList(to.path)) {
        // In the free login whitelist, go directly
        next();
      } else {
        validateUserTokenExisted(true) && validateUserTokenNotExpired(true);
        // Other pages that do not have permission to access are redirected to the login page.
        next(`/login?redirect=${to.path}`);
        AppModule.StopProgress();
      }
    }
  });

  router.afterEach(function(to: Route, from: Route) {
    // Finish progress bar
    AppModule.StopProgress();

    // set page title
    document.title = getPageTitle(to.meta.title);
  });
};
